import React from 'react';
import cls from './information.module.scss';
import { Card, Container } from '@material-ui/core';
import HelmetComponent from '../../components/HelmetComponent';
import { useTranslation } from 'react-i18next';
import CompanyTranslations from '../../components/CompanyTranslations';

const Translations = ({language}) => {
    const { t } = useTranslation();
    return (
        <main className={cls.information_container}>
        <HelmetComponent titlePage={t('helmet.translations.title',{ lng: language })} description={t('helmet.translations.description',{ lng: language })} title={t('helmet.translations.title',{ lng: language })} keywords={t('helmet.translations.keywords',{ lng: language })}/>
            <div style={{ position: 'relative'}}>
                <Container component="main" maxWidth="lg">
                    {/* </Container> */}
                    <Card className={cls.information_block_card}>
                    <CompanyTranslations language={language}/>
                    </Card>
                </Container>
            </div>
        </main>)
};

export default Translations;